import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {cx} from '@emotion/css';
import useBusinessLoanCalculator, {
  CalculatorParams,
} from '@fo/shared-data/useBusinessLoanCalculator/useBusinessLoanCalculator';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import {Device, useDevice} from '@fo/shared-providers/DeviceContext';
import {CURRENCY_SYMBOL} from '@fo/shared-types/constants';

import CalculatorForm, {CalculatorFormValues} from '../CalculatorForm/CalculatorForm';
import styles from './Calculator.styles';
import CalculatorResults from '../CalculatorResults/CalculatorResults';

interface Props {
  initialValues?: CalculatorFormValues;
}

function Calculator({initialValues}: Props): ReactElement {
  const {values: calculatorResults, submitCalculator, clearCalculator} = useBusinessLoanCalculator();
  const {device} = useDevice();
  const isMobile = device === Device.MOBILE;
  const defaultValue = '-';

  const submitForm = (values: CalculatorParams) => {
    submitCalculator(values);
  };

  const perMonthValues = () => {
    if (calculatorResults.monthlyPayable) {
      return {value: calculatorResults.monthlyPayable, currency: CURRENCY_SYMBOL};
    }

    return {value: defaultValue, currency: ''};
  };

  return (
    <div className={cx(styles.calculator)}>
      <div className={cx(styles.left)}>
        <CalculatorForm clearCalculator={clearCalculator} initialValues={initialValues} submitCalculator={submitForm} />
        <Paragraph className={cx(styles.info)}>
          <FormattedMessage id="businessLoanCalculator.info" />
        </Paragraph>
      </div>
      <div className={cx(styles.right)}>
        {isMobile && (
          <Paragraph className={cx(styles.perMonth)}>
            <FormattedMessage id="businessLoanCalculator.results.perMonth" values={perMonthValues()} />
          </Paragraph>
        )}
        <CalculatorResults values={calculatorResults} />
      </div>
    </div>
  );
}

export default Calculator;
